import * as React from "react";
import { cn } from "@/utils/common.utils";
import { Inbox, type LucideIcon } from "lucide-react";

interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  icon?: LucideIcon;
  compact?: boolean;
}

export default function EmptyState({ title, description, action, icon: Icon = Inbox, compact = false, className, ...props }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center rounded-2xl border border-dashed border-dash-border bg-white px-6 text-center",
        compact ? "py-10" : "py-16 sm:py-20",
        className
      )}
      {...props}
    >
      <span className="mb-4 flex size-11 items-center justify-center rounded-xl bg-dash-hover text-dash-greenDeep" aria-hidden="true">
        <Icon className="size-5" />
      </span>
      <h2 className={cn("font-semibold text-dash-ink", compact ? "text-base" : "text-xl")}>{title}</h2>
      {description && <p className="mx-auto mt-2 max-w-md text-sm text-dash-muted">{description}</p>}
      {action}
    </div>
  );
}
